import { render, staticRenderFns } from "./BrakepadsClassroom4.vue?vue&type=template&id=09770d9d&scoped=true"
import script from "./BrakepadsClassroom4.vue?vue&type=script&lang=js"
export * from "./BrakepadsClassroom4.vue?vue&type=script&lang=js"
import style0 from "./BrakepadsClassroom4.vue?vue&type=style&index=0&id=09770d9d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09770d9d",
  null
  
)

export default component.exports